import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import CustomCheckoutSignupStepper from "./CheckoutSignupStepper";

const CheckoutSignupPage6: React.FC = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Safe navigation wrapper
  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  useEffect(() => {
    const step2Completed = localStorage.getItem("step-2-completed");
    if (step2Completed) {
      safeNavigate("/glp1/getting-started/step-3");
    } else {
      safeNavigate("/glp1/getting-started/step-2");
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (option === "None of the Below") {
        return [option];
      }

      if (prevSelectedOptions.includes("None of the Below")) {
        return prevSelectedOptions
          .filter((item) => item !== "None of the Below")
          .concat(option);
      }

      if (prevSelectedOptions.includes(option)) {
        return prevSelectedOptions.filter((item) => item !== option);
      }

      return [...prevSelectedOptions, option];
    });
  };
  const handleBack = () => {
    safeNavigate("/glp1/getting-started/step-2");
  };

  const handleNext = () => {
    if (selectedOptions.length > 0) {
      localStorage.setItem(
        "previous_weight_loss_method",
        JSON.stringify({
          key: "previous_weight_loss_method",
          value: selectedOptions,
          id: 18026059,
        })
      );
    }
    safeNavigate("/glp1/getting-started/step-4");
    localStorage.setItem("step-3-completed", "true");
  };

  useEffect(() => {
    const savedPreviousWeightLossMethod = localStorage.getItem(
      "previous_weight_loss_method"
    );

    if (savedPreviousWeightLossMethod) {
      const parsedPreviousWeightLossMethod = JSON.parse(
        savedPreviousWeightLossMethod
      );
      setSelectedOptions(parsedPreviousWeightLossMethod.value || []);
    }
  }, []);

  const options = [
    "None of the Below",
    "Exercise",
    "Dieting",
    "Weight loss supplements",
    "Medical weight loss program",
  ];

  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomCheckoutSignupStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-content-header signup-content-heading-text">
            Your Experience with Weight loss methods?
          </p>
          <p
            className="signup-content-header-text signup-header-text"
            style={{ textAlign: "center" }}
          >
            Your past can tell us a lot about how we build your future.
          </p>
          <div className="options options-box-content options-box-contents">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOptions.includes(option) ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={selectedOptions.length === 0}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CheckoutSignupPage6;
